import graphql__57bf356db062ddb31b98 from "./__generated__/MapFilterTaxonomyFilterWithChildren_mapTaxonomy.graphql.js";import { useCallback, useState } from "react";
import { graphql, useFragment } from "react-relay";

import Collapse from "../../../Utils/Collapse";
import CollapseSwitch from "../../../Utils/CollapseSwitch";
import CollapseContent from "../../../Utils/CollapseContent";
import MapFilterTaxonomySelector from "./MapFilterTaxonomySelector";

const MapFilterTaxonomyFilterWithChildren = props => {
  const mapTaxonomy = useFragment(
    MapFilterTaxonomyFilterWithChildren_mapTaxonomy,
    props.mapTaxonomy
  );
  const { children } = mapTaxonomy;
  const { filterId, initiallyActive, isOpen, onFilterSelectorClicked } = props;

  const [wasOpen, setWasOpen] = useState(isOpen);

  // Only taxonomy ids are passed back, as Relay masks the fields this component's own
  // fragment doesn't declare : the filter resolves them against the taxonomies it holds.
  const handleExpandedChanged = useCallback(
    isExpanded => {
      if (isExpanded === isOpen) return;

      setWasOpen(isExpanded);
      onFilterSelectorClicked(mapTaxonomy.id);
    },
    [isOpen, onFilterSelectorClicked, mapTaxonomy.id]
  );

  const handleChildSelectorClicked = useCallback(
    childMapTaxonomy => {
      onFilterSelectorClicked(childMapTaxonomy.id);
    },
    [onFilterSelectorClicked]
  );

  const shouldCollapse = useCallback(() => !isOpen && wasOpen, [isOpen, wasOpen]);

  return (
    <div key={mapTaxonomy.id}>
      {/* The `expanded` prop only seeds the collapse's own state on mount, which is what
          we need here : a filter that starts by showing its elements must render its
          dropdowns open, and the `shouldCollapse` prop keeps them in sync afterwards. */}
      <Collapse
        expanded={isOpen}
        onExpandedChanged={handleExpandedChanged}
        shouldCollapse={shouldCollapse}
      >
        <CollapseSwitch className="w-100 btn-unstyled" hideCaret={true} headingLevel={3}>
          <MapFilterTaxonomySelector
            filterId={filterId}
            mapTaxonomy={mapTaxonomy}
            isActive={isOpen}
            // Avoid the MapFilterTaxonomySelector to be rendered with a wrapping <label>
            // tag and make it use a <span> tag, to avoid double click events which
            // prevents the collapse to be opened.
            WrapperElementTagName="span"
          />
        </CollapseSwitch>

        {children && (
          <CollapseContent>
            <div className="menu padding-left-sm">
              {children.map(childMapTaxonomy => (
                <MapFilterTaxonomySelector
                  key={childMapTaxonomy.id}
                  filterId={filterId}
                  initiallyActive={initiallyActive}
                  mapTaxonomy={childMapTaxonomy}
                  className="text-muted"
                  onClick={handleChildSelectorClicked}
                />
              ))}
            </div>
          </CollapseContent>
        )}
      </Collapse>
    </div>
  );
};

const MapFilterTaxonomyFilterWithChildren_mapTaxonomy = graphql__57bf356db062ddb31b98;

export default MapFilterTaxonomyFilterWithChildren;
